import * as React from "react";
import { createEmployeeCommission } from "../../libs/commission_calculator";
import Select from "react-select";
import * as moment from "moment";
import { get } from "lodash";
import { useCallback, useState } from "react";
import Loader from "../core/Loader";
import Button from "../core/Button";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { moneyFormatter } from "../../utils";
import { normalizeApiResponse } from "../../libs/api_utils";
import { useCommissionMonths } from "./common";

const cformat = num => (num ? moneyFormatter.format(num) : "");

interface IProps {
  user: IUser;
  selectedConfigId: string;
  commissions: ICommissionMonth[];
  commissionsPromise: IUsePromiseBag;
  history: RouteComponentProps["history"];
  isAdminView: boolean;
}

function CommissionsTable({
  user,
  selectedConfigId,
  history,
  commissions,
  commissionsPromise,
  isAdminView,
}: IProps) {
  const [isCreating, setIsCreating] = useState(false);
  const { year, possibleMonths, years, setYear } = useCommissionMonths();

  const startNewCommission = useCallback(
    async function startNewCommission(monthIndex) {
      setIsCreating(true);
      const resp = await createEmployeeCommission(user.id, {
        month: moment({ year, month: monthIndex, day: 1 }).toDate(),
        commissionConfigId: selectedConfigId,
      });
      // load the new commission into our data store
      commissionsPromise.setResult(commissions => [
        ...commissions,
        normalizeApiResponse(resp),
      ]);
      history.push(`/salespeople/${user.id}/${resp.data.id}`);
    },
    [user.id, year, selectedConfigId, commissionsPromise, history]
  );

  if (commissionsPromise.loading) {
    return <Loader />;
  }

  // think its pulling commisions that match the month without checking the year
  // so its pulling august 2019 for august 2020 
  const months = possibleMonths.map(month => {
    const commission = commissions.find(
      com => moment(com.month).month() === month.index && moment(com.month).year() == +year
    );

    return (
      <tr key={`${year}-${month.index}`}>
        <td>
          {month.name} {year}
        </td>
        <td>{cformat(get(commission, "resultCache.total"))}</td>
        <td>
          {commission ? (
            <Link
              className={"btn btn-default btn-sm"}
              to={`/salespeople/${user.id}/${commission.id}`}
            >
              <i className="fa fa-pencil-square" /> View/Edit
            </Link>
          ) : (
            <Button
              size={"sm"}
              onClick={() => startNewCommission(month.index)}
              loading={isCreating}
              disabled={!selectedConfigId || isCreating || isAdminView}
            >
              <i className="fa fa-plus-square" /> Start
            </Button>
          )}
        </td>
      </tr>
    );
  });

  return (
    <>
      <div className="columns">
        <div className="column">
          <Select
            value={{ label: year.toString(), value: year }}
            options={years.current.map(y => ({
              label: y.toString(),
              value: y,
            }))}
            onChange={(opt: ISelectOption) => setYear(opt.value)}
            clearable={false}
          />
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Month</th>
            <th>Total</th>
            <th />
          </tr>
        </thead>
        <tbody>{months}</tbody>
      </table>
    </>
  );
}

export default CommissionsTable;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionsTable.tsx